import React, {Component} from 'react';
import {
    List,
    Avatar,
    Card,
    Divider,
    Row,
    Col,
    Icon,
    Button,
    message,
} from 'antd';
import * as moment from 'moment';
import {Route, Switch, Redirect, NavLink, matchPath} from 'react-router-dom';
import Engineer from './Engineer';

class Engineers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            syncError: null
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {engineers: {isSyncing, syncError}} = nextProps;
        if (isSyncing) {
            return null;
        }

        if (syncError) {
            return {...prevState, syncError}
        }
        if (!syncError && prevState.syncError) {
            return {...prevState, syncError: null}
        }

        return null;
    }
    componentDidMount() {
        const {belongsTo, fetchEngineers} = this.props;
        return fetchEngineers(belongsTo);
    }
    render() {
        const {data, isFetching, isSyncing} = this.props.engineers;
        const {
            match,
            location: {pathname},
            belongsTo,
            syncEngineers,
            settings,
            updateEngineer,
            uploadEngineerDocument,
            deleteEngineerDocument,
            generateDocUrl,
            branches
        } = this.props;
        const generateUrl = (engineer, file) => generateDocUrl(belongsTo, engineer, file);
        const renderItem = item => {
            if (isFetching) return null;

            const {id, profile_photo, first_name, last_name} = item;
            const gsrDiff = moment(item.card_expiry_date.date, 'YYYY-MM-DD').diff(moment(), 'days');
            let gsrStatus = '#52c41a';
            if (gsrDiff < 0) {
                gsrStatus = '#f5222d';
            } else if (gsrDiff < 30) {
                gsrStatus = '#faad14'
            }
            const matchLocation = matchPath(pathname, {path: `${match.url}/:id`});
            const itemActive = matchLocation && (+matchLocation.params.id === item.id);

            const description = () => (
                <span>
                    Telephone: {item.phone_number || 'Not Available'}
                    <Divider type="vertical" />
                    Email: {item.email || 'Not Available'}
                </span>
            );

            return (
                <List.Item className={itemActive ? 'active' : ''} style={{paddingLeft: 12, paddingRight: 12}}>
                    <List.Item.Meta
                        avatar={<Avatar src={profile_photo} style={{
                            width: 48,
                            height: 48,
                            borderRadius: 25,
                            borderColor: gsrStatus,
                            borderStyle: 'solid',
                            borderWidth: 1
                        }}/>}
                        title={<NavLink style={{color: gsrStatus}} to={`${match.url}/${id}`}>{`${first_name} ${last_name}`}</NavLink>}
                        description={description()}
                    />
                </List.Item>
            );
        };
        const handlePostSync = () => {
            const {state: {syncError}} = this;
            if (!syncError) {
                message.success('Successfully sync\'ed from registry');
                return;
            }

            const {res: {message: error}} = syncError;
            message.error(error);
        };
        const sync = () =>
            syncEngineers(belongsTo).then(handlePostSync);
        const onUpdate = engineer => fields => {
            return updateEngineer(belongsTo, engineer, fields);
        };
        const handleUpload = (engineer) => ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
            formData.append(filename, file);

            return uploadEngineerDocument(belongsTo, engineer, formData).then(() => {
                const {uploadError} = this.props.engineers.data.find(d => d.id === engineer);
                if (!uploadError) {
                    file.status = 'done';
                    return onSuccess(file);
                }

                const {res: {errors, message}} = uploadError;
                file.status = 'error';
                file.response = message;
                return onError(file);
            });
        };
        const onDelete = (engineer) => (doc) => {
            return deleteEngineerDocument(belongsTo, engineer, doc.uid);
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>License Card Holders</span>
            </div>
        );
        const extra = () => {
            return <Button onClick={sync}><Icon type="sync" spin={isSyncing}/> Sync from Gas Safe Register</Button>;
        };
        return (
            <Card title={title()} loading={isFetching} bordered={false} extra={extra()}>
                <Row gutter={16}>
                    <Col md={{span: 12}}>
                        <List
                            itemLayout="horizontal"
                            dataSource={data}
                            renderItem={renderItem}
                        />
                    </Col>
                    <Col md={{span: 12}}>
                        <Switch>
                            <Route path={`${match.url}/:id`} render={props => {
                                if (isFetching || !data.length) return null;

                                const {match: {params: {id}}} = props;
                                const engineer = data.find(i => i.id === +id);

                                return <Engineer
                                    {...props}
                                    engineer={engineer}
                                    settings={settings}
                                    onUpdate={onUpdate(engineer.id)}
                                    onUpload={handleUpload(engineer.id)}
                                    onDelete={onDelete(engineer.id)}
                                    generateUrl={generateUrl}
                                    branches={branches}
                                />;
                            }} />
                            {data.length ? <Redirect from={`${match.url}`} to={`${match.url}/${data[0].id}`}/> : null}
                        </Switch>
                    </Col>
                </Row>
            </Card>
        );
    }
}

export default Engineers;


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/Engineers.js